import { Tag } from '../../types/shared';

import { isBrowser } from '../generic';

import { DEQ_TYPES } from './deq.constants';

export const trackTag = (tag: Tag, compType: string) => {
  if (!isBrowser || !window.aabAnalytics) return;

  window.aabAnalytics.push({
    command: 'ADD EVENT',
    name: 'click',
    data: {
      html_component_type: compType,
      html_element_label: tag.value,
      html_element_type: DEQ_TYPES.tab,
    },
  });
};
